import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';

import type { IconName, TooltipPosition, IconToken } from '@core/user-interface-legacy';
import { IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-feature-item',
  templateUrl: './feature-item.component.html',
  styleUrls: ['./feature-item.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RtTooltip, IconComponent],
})
export class FeatureItemComponent {
  public readonly label = input<string>(undefined!);
  public readonly tooltip = input<string>();
  public readonly isBold = input<boolean>();

  @Input() public set icon(value: IconName | undefined) {
    this._icon = value || 'check';
  }
  public get icon(): IconName {
    return this._icon;
  }

  @Input() public set tooltipPosition(value: TooltipPosition | undefined) {
    this._tooltipPosition = value || 'right';
  }
  public get tooltipPosition(): TooltipPosition {
    return this._tooltipPosition;
  }

  public get iconColor() {
    return this.icon === 'add-circle-outline'
      ? <IconToken>'colorIconSuccessDefault'
      : 'colorIconStrongDefault';
  }

  private _icon: IconName = 'check';
  private _tooltipPosition: TooltipPosition = 'right';
}
